module.exports = __webpack_public_path__ + "img/IMG_7224.88e37283.webp";